import { Auth } from 'aws-amplify';
import { AbstractApiService, TokenProvider } from './abstractApiService';
import { EnvironmentService } from './environment.service';

class SharedTokenProvider implements TokenProvider {
  public async currentToken(): Promise<string> {
    const session = await Auth.currentSession();
    return session.getAccessToken().getJwtToken();
  }
}

export type FeatureFlags = {
  allowOpenSignUp: boolean;
  allowPSPPayments: boolean;
  allowProfileEditing: boolean;
  allowPSPOnboarding: boolean;
  allowAutomaticIdentityVerification: boolean;
  allowExpenses: boolean;
  allowCertificateBlock: boolean;
  allowFreelancerEmploymentType: boolean;
  allowTempWorkerEmploymentType: boolean;
  allowRequiredVatForWorkActions: boolean;
  allowRequiredCocForWorkActions: boolean;
  allowCollectiveInvoices: boolean;
  allowAutomatedCollectiveInvoice: boolean;
  allowRequireGeneralAvailability: boolean;
  allowProjectApplications: boolean;
  allowPlatformServiceFee: boolean;
  allowCvScreensInOnboardingStarter: boolean;
  allowCandidateOnboarding: boolean;
  allowCsvForCollectiveInvoices: boolean;
  allowEmploymentId: boolean;
  allowReverseChargingVAT: boolean;
  disableTempWorkStarterOnboarding: boolean;
  allowGrossHourlyRateVisibleInOgp: boolean;
  allowReplacements: boolean;
  allowDocuments: boolean;
  allowCsvShiftImport: boolean;
  allowWorkflows: boolean;
  allowCollegialLending: boolean;
  allowWorkerSSO: boolean;
  allowOGPSSO: boolean;
  allowBorrowedWorkforce: boolean;
};

export type EnvironmentConfigurationResponse = {
  backend: {
    platformClient: string;
    featureFlags: FeatureFlags;
    platformSettings: PlatformSettings;
  };
  payment?: {
    platformClient: string;
    allowSalaryPaymentCreation: boolean;
  };
};

export type PlatformSettings = {
  noShowBailCents: number;
  minimumTempWorkerAge: number;
};

class SharedApiServiceImpl extends AbstractApiService {
  constructor(endpoint: string) {
    super(endpoint, new SharedTokenProvider());
  }

  public getEnvironmentConfiguration = async (): Promise<EnvironmentConfigurationResponse> => {
    const { backend, payment } = await this.getBackendEnvironmentConfiguration();
    return {
      payment,
      backend,
    };
  };

  private async getBackendEnvironmentConfiguration() {
    const response = await this.get<EnvironmentConfigurationResponse>({
      path: `environment-configuration`,
    });

    return response;
  }
}

const ogpUri = EnvironmentService.getVariable('BACKEND_OGP_URI').slice(0, -1).split('/');
ogpUri.pop();
export const endpoint = ogpUri.join('/') + '/';

export const SharedApiService = new SharedApiServiceImpl(endpoint);
